import { render, staticRenderFns } from "./SearchContacts.vue?vue&type=template&id=5b05a3a3&"
import script from "./SearchContacts.vue?vue&type=script&lang=js&"
export * from "./SearchContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports